import { auth } from './firebase';
import { signInAnonymously, onAuthStateChanged } from 'firebase/auth';

let authReady = null;

export function ensureAuth() {
  if (!authReady) {
    authReady = new Promise((resolve) => {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          resolve(user);
        } else {
          signInAnonymously(auth)
            .then((credential) => resolve(credential.user))
            .catch((err) => {
              console.warn('[Auth] Anonymous sign-in failed:', err.message);
              resolve(null);
            });
        }
      });
    });
  }
  return authReady;
}
